<template>
    <div class="sidebar-logo-container" :class="{ collapse: collapse }">
        <transition name="sidebarLogoFade">
            <!-- <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
                <img
                    v-if="logo || defaultLogo"
                    :src="logo ? logo : defaultLogo"
                    class="sidebar-logo"
                />
                <h1 v-else class="sidebar-title">{{ title }}</h1>
            </router-link>
            <router-link v-else key="expand" class="sidebar-logo-link" to="/">
                <img
                    v-if="logo || defaultLogo"
                    :src="logo ? logo : defaultLogo"
                    class="sidebar-logo"
                />
                <h1 class="sidebar-title">{{ title }}</h1>
            </router-link> -->
            <div v-if="collapse" key="collapse" class="sidebar-logo-link">
                <img
                    v-if="logo || defaultLogo"
                    :src="logo ? logo : defaultLogo"
                    class="sidebar-logo"
                />
                <h1 v-else class="sidebar-title">{{ title }}</h1>
            </div>
            <div v-else key="expand" class="sidebar-logo-link">
                <img
                    v-if="logo || defaultLogo"
                    :src="logo ? logo : defaultLogo"
                    class="sidebar-logo"
                />
                <h1 class="sidebar-title">{{ title }}</h1>
            </div>
        </transition>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
    name: "SidebarLogo",
    props: {
        collapse: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            defaultLogo: require("@/assets/img/logo.png"),
        };
    },
    computed: {
        ...mapGetters(["logo"]),
        ...mapState("user", {
            title: (state) => state.enterpriseName,
        }),
        /* ...mapState("settings", {
            title: (state) => state.title,
        }), */
    },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
    transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
    opacity: 0;
}

.sidebar-logo-container {
    position: relative;
    width: 100%;
    height: 50px;
    // line-height: 50px;
    //   background: #2b2f3a;
    background: #fff;
    text-align: center;
    overflow: hidden;

    & .sidebar-logo-link {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        & .sidebar-logo {
            width: 32px;
            height: 32px;
            vertical-align: middle;
            margin: 0 10px;
        }

        & .sidebar-title {
            display: inline-block;
            margin: 0;
            color: #000;
            font-weight: 600;
            // line-height: 50px;
            font-size: 14px;
            // font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
            vertical-align: middle;
        }
    }

    &.collapse {
        .sidebar-logo {
            margin-right: 0px;
        }
    }
}
</style>
